import React, { lazy, Suspense } from "react";
import { SuspenseLoader } from "../../../assets/loaders";

const LazyComponent = lazy(() => import("./FeatureSetting"));

export default function FeatureSetting() {
  return (
    <Suspense fallback={<SuspenseLoader />}>
      <LazyComponent />
    </Suspense>
  );
}
